/**
 * JWT 토큰을 디코딩하여 페이로드를 반환하는 함수
 * @param token JWT 토큰
 * @returns 디코딩된 JWT 페이로드
 */
export function decodeJWT(token: string): any {
  try {
    // JWT는 Header.Payload.Signature 형식이므로 Payload 부분만 추출
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("JWT 디코딩 실패:", error);
    return null;
  }
}

/**
 * JWT 토큰에서 사용자 역할을 추출하는 함수
 * @param token JWT 토큰
 * @returns 사용자 역할 (예: "admin", "student") 또는 null
 */
export function getUserRoleFromToken(token: string): string | null {
  const decoded = decodeJWT(token);
  if (!decoded) return null;

  // 여기서는 토큰 페이로드에 role 필드가 있다고 가정합니다.
  // 실제 구현에서는 토큰 구조에 맞게 조정해야 합니다.
  return decoded.role || null;
}
